// src/PublicRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PublicRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  // While auth is loading, don't decide yet (avoids flicker/incorrect redirect)
  if (loading) return null;

  // If the user is already logged in, redirect to the dashboard
  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;
